import { render } from "./ChoicePromptCard.vue?vue&type=template&id=8df1a710&scoped=true"
import script from "./ChoicePromptCard.vue?vue&type=script&lang=js"
export * from "./ChoicePromptCard.vue?vue&type=script&lang=js"

import "./ChoicePromptCard.vue?vue&type=style&index=0&id=8df1a710&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df1a710"]])

export default __exports__